<template>
  <Select
    :items="arrayStatus"
    :selectedItem="filter.status"
    label="Status"
    searchPlaceholder="Buscar status"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        status: {
          id: "",
          name: "",
        },
      },
      arrayStatus: [
        { id: "D", name: "Em digitação" },
        { id: "F", name: "Finalizada" },
        { id: "T", name: "Aguardando consulta" },
        { id: "A", name: "Aceita" },
        { id: "R", name: "Rejeitada" },
        { id: "C", name: "Cancelada" },
        { id: "N", name: "Denegada" },
        { id: "protocoladas", name: "Com valor fiscal" },
      ],
    };
  },
  methods: {
    atualizar(status) {
      this.filter.status = status;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.status.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.status.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayStatus, this.filter.status);
  },
}
</script>
